import React, { useEffect, useState, useContext, createContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/ConformationPopup/Popup';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import { checkRoleEvaluation, deleteGoal } from '../../service/PerformanceAPI';
import { encryptStorage, UserContext } from '../../constant';

export default function SingleGoal({ role, type, index, employeeGoals, eachGoal, evaluationShow, eachteamgoal }) {
    const navigate = useNavigate();
    const user = useContext(UserContext);

    let details = { role: '', roleId: '', domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [EvaluationShow, setEvaluationShow] = useState({});

    useEffect(() => {
        if (Object.keys(evaluationShow).length > 0) setEvaluationShow(evaluationShow);
    }, [evaluationShow]);

    useEffect(() => {
        userDetails.roleId = encryptStorage.getItem('employeeId');
    }, []);

    const EditGoal = async (id) => {
        navigate(`/goalform/${id}`);
    };

    const GoalView = async (id, empId) => {
        let role;
        if (encryptStorage.getItem('employeeId') === empId) {
            role = 'Team Member';
        } else {
            let checkrole = await checkRoleEvaluation({ viewerId: encryptStorage.getItem('employeeId'), empId: empId });
            if (checkrole.data.statusCode == 200) {
                role = checkrole.data.ResponseData === 'Manager' ? checkrole.data.ResponseData : 'Hr Manager';
            }
        }
        navigate(`/goalview/${id}`, { state: { role: role } });
    };



    const bindIndividualGoal = () => {
        return (
            <>
                <li className="my-2 goal-inner-accordiansty goal-li-sty py-3 px-3">
                    <div className="d-flex justify-content-between border-none goal-inner-accordiansty">
                        <div className="col-md-5 d-flex align-self-center">
                            <div className="d-block align-self-center">
                                <a className="text-deco-none">
                                    <img src="/Images/orange-arrow.svg" alt="orange-arrow" className="me-2" />
                                </a>
                            </div>
                            <div
                                onClick={() => {
                                    GoalView(eachGoal.id, eachGoal.assigned_to_id);
                                }}
                                className="d-block align-self-center"
                            >
                                <p className="font-15 mb-0 bold-text mygoal-para">{eachGoal.goal_name}</p>
                            </div>
                        </div>
                        <div className="col-md-2 align-self-center text-center">
                            {eachGoal.manager_rating === null || eachGoal.manager_rating === undefined || eachGoal.manager_rating === '' ? (
                                <span className="right-arrow bold-text font-15 tt-bold text-skyblue">-</span>
                            ) : (
                                <>
                                    <img
                                        src={
                                            !eachGoal?.manager_rating
                                                ? null
                                                : eachGoal?.manager_rating.includes('+')
                                                    ? `/Images/${eachGoal?.manager_rating?.slice(0, -1)}_plus.png`
                                                    : eachGoal?.manager_rating.includes('-')
                                                        ? `/Images/${eachGoal?.manager_rating?.slice(0, -1)}_minus.png`
                                                        : null
                                        }
                                        className="emoji-sty"
                                        alt="excited-emoji"
                                    ></img>
                                    <span className="right-arrow bold-text font-15 tt-bold text-skyblue">{eachGoal.manager_rating}</span>
                                </>
                            )}
                        </div>
                        <div className="col-md-2 d-flex align-self-center">
                            <div className="d-block align-self-center">
                                <span className="semibold-text gray-text font-15 pe-2">{eachGoal.progress}%</span>
                            </div>
                            <div className="d-block progress progress-style align-self-center">
                                <div
                                    className="progress-bar progress-style bg-info"
                                    role="progressbar"
                                    style={{
                                        width: `${eachGoal.progress}%`,
                                    }}
                                    aria-valuenow={50}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                        </div>
                        <div className="col-md-2 text-center align-self-center">
                            <span className={`status-btn font-14 ${eachGoal.color}`}>{eachGoal.status}</span>
                        </div>
                        {/* Kebab Menu starts Here */}

                        <div className="dropend me-4 align-self-center">
                            <button
                                type="button"
                                className="btn p-0 align-self-center kebab-btn-sty"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <span>
                                    <img src="/Images/kebab-icon.svg" className="kebab-size" />
                                </span>
                            </button>
                            <ul className="dropdown-menu optionboxsize shadow border-0">
                                {eachGoal.status == 'Completed' ||
                                    evaluationShow?.currentEvaluation == 0 ||
                                    eachGoal.assigned_by_id != userDetails.roleId ? (
                                    <>
                                        <li
                                            onClick={() => {
                                                user?.setTriggerEmpId(eachGoal.assigned_to_id);
                                                user?.setGoalId(eachGoal.id);
                                                user?.setGoalName(eachGoal.goal_name);
                                                user?.setCopyTo(true);
                                            }}
                                            data-bs-toggle="modal"
                                            data-bs-target={role === 'Manager' ? 'manager-Copyto' : '#org-Copyto'}
                                        >
                                            <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1">
                                                <span>
                                                    <img className="pe-2 mb-2 mt-1" style={{ "width": "20px" }} src="/Images/recruit-copy.svg" />
                                                </span>
                                                Copy
                                            </a>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li
                                            onClick={() => {
                                                EditGoal(eachGoal.id);
                                            }}
                                        >
                                            <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1">
                                                <span>
                                                    <img className="pe-2 mb-2" src="/Images/pencil-icon.svg" />
                                                </span>
                                                Edit
                                            </a>
                                        </li>
                                        <li
                                            data-bs-toggle="modal"
                                            data-bs-target={role === 'Manager' ? '#manager-Delete' : '#Org-Delete'}
                                            onClick={() => {
                                               
                                                user?.setGoalId(eachGoal.id);
                                                user?.setTriggerEmpId(eachGoal.assigned_to_id);
                                                user?.setTypeOfDelete('');
                                            }}
                                        >
                                            <a className="dropdown-item dditems semibold-text fontcolor-1 fontsize12">
                                                <span>
                                                    <img className="pe-2" src="/Images/delete-bin-icon.svg" />
                                                </span>
                                                Delete
                                            </a>
                                        </li>
                                        <li
                                            onClick={() => {
                                                user?.setTriggerEmpId(eachGoal.assigned_to_id);
                                                user?.setGoalId(eachGoal.id);
                                                user?.setGoalName(eachGoal.goal_name);
                                                user?.setCopyTo(true);
                                            }}
                                            data-bs-toggle="modal"
                                            data-bs-target={role === 'Manager' ? 'manager-Copyto' : '#org-Copyto'}
                                        >
                                            <a className="dropdown-item dditems semibold-text fontsize12 fontcolor-1">
                                                <span>
                                                    <img className="pe-2 mb-2 mt-1" style={{ "width": "20px" }} src="/Images/recruit-copy.svg" />
                                                </span>
                                                Copy
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                        {/* Kebab Menu ends Here */}
                    </div>
                </li>
            </>
        );
    };

    const bindTeamGoal = () => {
        return (
            <>
                <li className="my-2 goal-bg-color goal-li-sty py-3 px-3">
                    <div className="d-flex justify-content-between border-none goal-bg-color">
                        <div className="col-md-5 d-flex align-self-center">
                            <div className="d-flex">
                                <div className="d-block align-self-center">
                                    <img src="/Images/logo-person-user-person-icon.jpg" className="profile-pic" alt="creator-name" />
                                </div>
                                <div
                                    onClick={() => {
                                       
                                        GoalView(eachteamgoal.id, eachteamgoal.assigned_to_id);
                                    }}
                                    className="d-block align-self-center"
                                >
                                    <p className="ms-3 mb-0 gray-text font-15 medium-text">{eachteamgoal.assignedto}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 align-self-center text-center">
                            {eachteamgoal.manager_rating === null ||
                                eachteamgoal.manager_rating === undefined ||
                                eachteamgoal.manager_rating === '' ? (
                                <span className="right-arrow bold-text font-15 tt-bold text-skyblue">-</span>
                            ) : (
                                <>
                                    <img
                                        src={
                                            !eachteamgoal?.manager_rating
                                                ? null
                                                : eachteamgoal?.manager_rating.includes('+')
                                                    ? `/Images/${eachteamgoal?.manager_rating?.slice(0, -1)}_plus.png`
                                                    : eachteamgoal?.manager_rating.includes('-')
                                                        ? `/Images/${eachteamgoal?.manager_rating?.slice(0, -1)}_minus.png`
                                                        : null
                                        }
                                        className="emoji-sty"
                                        alt="excited-emoji"
                                    ></img>
                                    <span className="right-arrow bold-text font-15 tt-bold text-skyblue">
                                        {eachteamgoal.manager_rating}
                                    </span>
                                </>
                            )}
                        </div>
                        <div className="col-md-2 d-flex align-self-center">
                            <div className="d-block align-self-center">
                                <span className="semibold-text gray-text font-15 pe-2">{eachteamgoal.progress}%</span>
                            </div>
                            <div className="d-block progress progress-style align-self-center">
                                <div
                                    className="progress-bar progress-style bg-info"
                                    role="progressbar"
                                    style={{
                                        width: `${eachteamgoal.progress}%`,
                                    }}
                                    aria-valuenow={50}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                        </div>
                        <div className="col-md-2 text-center align-self-center">
                            <span className={`status-btn ${eachteamgoal.color} font-14`}>{eachteamgoal.status}</span>
                        </div>
                    </div>
                </li>
            </>
        );
    };

    return type == 'individual' ? bindIndividualGoal() : bindTeamGoal();
}
